export const CalendarConstant = {
	SET_NEW: 'GET_SET_NEW',
	GET_SCHLIST: 'GET_SCHLIST',
	GET_SCH: 'GET_SCH',
	CREATE_SCH: 'CREATE_SCH',
	UPDATE_SCH: 'UPDATE_SCH',
	DELETE_SCH: 'DELETE_SCH',
    LOADING: 'CAL_LOADING',
    LOADED: 'CAL_LOADED',
};